import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type React.FC<propTypes>
 */
const ModuleFootnoteBlock = ({
    isAccordionOrSection = null,
    items = []
}) => {
    if (items?.length < 1) {
        return;
    }

    return (
        <section className={`layout-container relative my-40${isAccordionOrSection ? ' md:my-60' : ' md:mt-80 md:mb-60'}`}>
            <div className='layout-grid-negative-gutter md:flex'>
                <div className='md:w-5/12 layout-grid-col-padding' />

                <div className='md:w-6/12'>
                    <h2 className='layout-grid-col-padding mb-30'>
                        Footnotes
                    </h2>

                    <ul className='footnotes layout-grid-col-padding flex flex-col gap-20'>
                        {items.map((itm, idx) => {
                            return (
                                <li
                                    className='flex items-start'
                                    id={itm.referenceId}
                                    key={idx}>
                                    <sup className='top-10 mr-10 flex-shrink-0'>
                                        {itm.referenceLabel}
                                    </sup>

                                    <div
                                        className='rich-text'
                                        dangerouslySetInnerHTML={{ __html: itm.note }}/>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array.isRequired,
    isAccordionOrSection: PropTypes.bool
};

ModuleFootnoteBlock.propTypes = propTypes;

export default ModuleFootnoteBlock;
